export const FETCH_ENCOUNTERS_REQUEST = 'FETCH_ENCOUNTERS_REQUEST';
export const FETCH_ENCOUNTERS_SUCCESS = 'FETCH_ENCOUNTERS_SUCCESS';
export const FETCH_ENCOUNTERS_FAILURE = 'FETCH_ENCOUNTERS_FAILURE';

export const CREATE_ENCOUNTER_REQUEST = 'CREATE_ENCOUNTER_REQUEST';
export const CREATE_ENCOUNTER_SUCCESS = 'CREATE_ENCOUNTER_SUCCESS';
export const CREATE_ENCOUNTER_FAILURE = 'CREATE_ENCOUNTER_FAILURE';

export const UPDATE_ENCOUNTER_REQUEST = 'UPDATE_ENCOUNTER_REQUEST';
export const UPDATE_ENCOUNTER_SUCCESS = 'UPDATE_ENCOUNTER_SUCCESS';
export const UPDATE_ENCOUNTER_FAILURE = 'UPDATE_ENCOUNTER_FAILURE';

export const DELETE_ENCOUNTER_REQUEST = 'DELETE_ENCOUNTER_REQUEST';
export const DELETE_ENCOUNTER_SUCCESS = 'DELETE_ENCOUNTER_SUCCESS';
export const DELETE_ENCOUNTER_FAILURE = 'DELETE_ENCOUNTER_FAILURE';

export const fetchEncountersRequest = (projectId, options = {}) => {
    const { page = 1, limit = 1, search = '' } = options;
    return {
        type: FETCH_ENCOUNTERS_REQUEST,
        payload: { projectId,page, limit, search },
        
      }; 
    };
export const fetchEncountersSuccess = (encounters) => ({ type: FETCH_ENCOUNTERS_SUCCESS, payload: encounters });
export const fetchEncountersFailure = (error) => ({ type: FETCH_ENCOUNTERS_FAILURE, payload: error });

export const createEncounterRequest = (data, projectId) => ({ type: CREATE_ENCOUNTER_REQUEST, payload: { data, projectId } });
export const createEncounterSuccess = (encounter) => ({ type: CREATE_ENCOUNTER_SUCCESS, payload: encounter });
export const createEncounterFailure = (error) => ({ type: CREATE_ENCOUNTER_FAILURE, payload: error });

export const updateEncounterRequest = (id, data,projectId) => ({ type: UPDATE_ENCOUNTER_REQUEST, payload: { id, data ,projectId} });
export const updateEncounterSuccess = (encounter) => ({ type: UPDATE_ENCOUNTER_SUCCESS, payload: encounter });
export const updateEncounterFailure = (error) => ({ type: UPDATE_ENCOUNTER_FAILURE, payload: error });

export const deleteEncounterRequest = (id,projectId) => ({ type: DELETE_ENCOUNTER_REQUEST, payload: {id,projectId} });
export const deleteEncounterSuccess = (id) => ({ type: DELETE_ENCOUNTER_SUCCESS, payload: id });
export const deleteEncounterFailure = (error) => ({ type: DELETE_ENCOUNTER_FAILURE, payload: error });
